import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Injectable} from '@angular/core';
import {SectionBase} from './base.section';
import {EditAssessmentRequestModel} from '../../edit-assessment-request.model';
@Injectable()
export class QuestionsCommentsSection extends SectionBase {
  constructor(private fb: UntypedFormBuilder) {
    super();
  }
  public get questionsCommentsControl() {
    return this.formGroup.controls['questionsComments'] as UntypedFormControl;
  }
  
  public init({assessmentRequest}: { assessmentRequest: EditAssessmentRequestModel }) {
    super.setAssessmentRequest(assessmentRequest);
    this.formGroup = this.buildFormGroup();
    this.questionsCommentsControl.setValue(this.assessmentRequest.questionsComments);
  }
  public get formValue(): any {
    const values = this.formGroup.value;
    return {
      questionsComments: values.questionsComments
    };
  }
  protected buildFormGroup(): UntypedFormGroup {
    return this.fb.group({
      questionsComments: null
    });
  }
}